import { type PropsWithChildren, type ReactNode, useEffect, useState } from 'react';
import { useResizeDetector } from 'react-resize-detector';

import clsx from 'clsx';
import classes from './styles.module.css';

type ProjectHeaderProps = {
    sticky?: boolean;
    children?: ReactNode;
};

const DEFAULT_HEADER_HEIGHT = 77;

const NavigationPanel = ({ sticky, children }: ProjectHeaderProps) => {
    // need to detect when headerRef changes height to avoid sticky header glitch
    const { ref: headerRef, height } = useResizeDetector({
        refreshMode: 'debounce',
        refreshRate: 0,
    });
    const [hasScrolled, setHasScrolled] = useState(false);

    const staticEnabled = () => {
        if (!hasScrolled) {
            return true;
        }

        return !sticky;
    };

    useEffect(() => {
        const onScroll = () => {
            setHasScrolled(window.scrollY > 0);
        };
        window.addEventListener('scroll', onScroll);

        return () => window.removeEventListener('scroll', onScroll);
    }, [hasScrolled]);

    const minHeight = `${height || DEFAULT_HEADER_HEIGHT}px`;

    return (
        <div style={{ minHeight }}>
            <div>
                <div
                    ref={headerRef}
                    className={clsx(classes.headerContent, {
                        [classes.staticEnabled]: staticEnabled(),
                    })}
                >
                    <NavigationPanel.Header />
                    <NavigationPanel.Tabs />
                    {children}
                </div>
            </div>
        </div>
    );
};

NavigationPanel.Header = ({ children }: PropsWithChildren) => <div className={classes.headerContainer}>{children}</div>;

NavigationPanel.Tabs = ({ children }: PropsWithChildren) => <div className={classes.tabsContainer}>{children}</div>;

export default NavigationPanel;
